import classnames from 'classnames';
import IconClear from './icon_clear.svg';
import s from './index.module.scss';

export const TextField = ({
  label,
  name,
  value,
  placeholder,
  onChange,
  onClear,
  error,
  description,
  rightContainer,
}) => {
  return (
    <div className={s.wrapper}>
      {label && (
        <label
          id={name}
          htmlFor={name}
          className={classnames(s.label, 'f-small-accent')}
        >
          {label}
        </label>
      )}
      <div className={s.container}>
        <div className={s.left_container}></div>
        <input
          type="text"
          className={classnames(s.input, error && s.input_error)}
          value={value}
          onChange={e => onChange(e.target.value)}
          placeholder={placeholder}
        />
        <div className={s.right_container}>
          {rightContainer ||
            (onClear && !!value && (
              <button type="button" className={s.btn_clear} onClick={onClear}>
                <img src={IconClear} width={24} height={24} alt="clear" />
              </button>
            ))}
        </div>
      </div>
      {error ? (
        <div className={classnames(s.error, 'f-small-regular')}>{error}</div>
      ) : (
        description && (
          <div className={classnames(s.description, 'f-small-regular')}>
            {description}
          </div>
        )
      )}
    </div>
  );
};
